import React from 'react';

import { Skeleton } from '@repo/ui/components/ui/skeleton';

export const KeySourcesSectionSkeleton: React.FC = () => {
  return (
    <div className="space-y-2">
      <div className="flex w-full px-3">
        <Skeleton className="h-4.5 w-20 rounded-md bg-[#2D3748]" />
      </div>
      <div className="px-3">
        <div className="grid grid-cols-3 gap-2">
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
          <Skeleton className="h-4.5 w-full rounded-full bg-[#2D3748]" />
        </div>
      </div>
    </div>
  );
};
